/**
 * Placeholder user & access data. Replace with the identity API: directory,
 * role catalogue and the access-change audit feed.
 */

export const USER_STATS = [
  {
    key: "total",
    label: "Total Users",
    value: "186",
    foot: "All accounts",
    tone: "blue",
    icon: "users",
  },
  {
    key: "active",
    label: "Active Users",
    value: "172",
    foot: "92.5% of accounts",
    footTone: "good",
    tone: "green",
    icon: "check",
  },
  {
    key: "pending",
    label: "Pending Invites",
    value: "6",
    foot: "Awaiting first sign-in",
    tone: "amber",
    icon: "mail",
  },
  {
    key: "roles",
    label: "Roles Defined",
    value: "8",
    foot: "Across 5 departments",
    tone: "indigo",
    icon: "shield",
  },
  {
    key: "locked",
    label: "Locked Accounts",
    value: "3",
    foot: "Require unlock",
    footTone: "warn",
    tone: "red",
    icon: "lock",
  },
];

export const ROLE_NAMES = [
  "Super Administrator",
  "Tax Officer",
  "Auditor",
  "Data Steward",
  "Read Only",
];

export const DEPARTMENTS = [
  "IT Department",
  "Taxpayer Services",
  "Audit",
  "Data Quality",
  "Compliance",
];

export const USER_STATUSES = ["Active", "Pending", "Locked", "Disabled"];

export const TOTAL_USERS = 186;

export const USERS = [
  {
    id: 1,
    name: "John Doe",
    email: "john.doe@dgi.gov.ao",
    role: "Super Administrator",
    department: "IT Department",
    status: "Active",
    lastDate: "01 Sep 2026",
    lastTime: "10:30 AM",
  },
  {
    id: 2,
    name: "Jane Smith",
    email: "jane.smith@dgi.gov.ao",
    role: "Tax Officer",
    department: "Taxpayer Services",
    status: "Active",
    lastDate: "01 Sep 2026",
    lastTime: "10:28 AM",
  },
  {
    id: 3,
    name: "Maria Fernandes",
    email: "maria.fernandes@dgi.gov.ao",
    role: "Auditor",
    department: "Audit",
    status: "Active",
    lastDate: "01 Sep 2026",
    lastTime: "10:20 AM",
  },
  {
    id: 4,
    name: "Carlos Alberto",
    email: "carlos.alberto@dgi.gov.ao",
    role: "Data Steward",
    department: "Data Quality",
    status: "Active",
    lastDate: "01 Sep 2026",
    lastTime: "10:15 AM",
  },
  {
    id: 5,
    name: "Ana Pereira",
    email: "ana.pereira@dgi.gov.ao",
    role: "Tax Officer",
    department: "Compliance",
    status: "Active",
    lastDate: "01 Sep 2026",
    lastTime: "10:08 AM",
  },
  {
    id: 6,
    name: "Joao Manuel",
    email: "joao.manuel@dgi.gov.ao",
    role: "Read Only",
    department: "Taxpayer Services",
    status: "Pending",
    lastDate: "—",
    lastTime: "Never signed in",
  },
  {
    id: 7,
    name: "Bruno Costa",
    email: "bruno.costa@dgi.gov.ao",
    role: "Tax Officer",
    department: "Compliance",
    status: "Locked",
    lastDate: "29 Aug 2026",
    lastTime: "04:52 PM",
  },
  {
    id: 8,
    name: "Paulo Costa",
    email: "paulo.costa@dgi.gov.ao",
    role: "Auditor",
    department: "Audit",
    status: "Disabled",
    lastDate: "12 Aug 2026",
    lastTime: "09:11 AM",
  },
];

/**
 * Role colours come from the validated categorical set used elsewhere in the
 * app; the role name is always shown, so colour is a secondary cue.
 */
export const ROLE_BREAKDOWN = [
  {
    label: "Tax Officer",
    value: 74,
    share: 39.8,
    color: "#0072b2",
    legendPrimary: "74",
    legendSecondary: "(39.8%)",
  },
  {
    label: "Read Only",
    value: 48,
    share: 25.8,
    color: "#009e73",
    legendPrimary: "48",
    legendSecondary: "(25.8%)",
  },
  {
    label: "Auditor",
    value: 32,
    share: 17.2,
    color: "#e69f00",
    legendPrimary: "32",
    legendSecondary: "(17.2%)",
  },
  {
    label: "Data Steward",
    value: 20,
    share: 10.8,
    color: "#cc79a7",
    legendPrimary: "20",
    legendSecondary: "(10.8%)",
  },
  {
    label: "Super Administrator",
    value: 12,
    share: 6.4,
    color: "#d55e00",
    legendPrimary: "12",
    legendSecondary: "(6.4%)",
  },
];

export const ACCESS_CHANGES = [
  {
    id: 1,
    title: "Role changed to Auditor",
    who: "Maria Fernandes",
    by: "John Doe",
    when: "01 Sep 2026, 09:45 AM",
    tone: "info",
  },
  {
    id: 2,
    title: "Account locked after failed logins",
    who: "Bruno Costa",
    by: "System",
    when: "29 Aug 2026, 04:55 PM",
    tone: "critical",
  },
  {
    id: 3,
    title: "Invite sent",
    who: "Joao Manuel",
    by: "Jane Smith",
    when: "28 Aug 2026, 02:10 PM",
    tone: "warning",
  },
  {
    id: 4,
    title: "Account disabled",
    who: "Paulo Costa",
    by: "John Doe",
    when: "12 Aug 2026, 09:30 AM",
    tone: "muted",
  },
];

export const ROLES = [
  {
    key: "super",
    name: "Super Administrator",
    description: "Full access to every module, including settings and audit.",
    users: 12,
    permissions: 48,
  },
  {
    key: "officer",
    name: "Tax Officer",
    description: "Manage taxpayers, NIF registration and compliance cases.",
    users: 74,
    permissions: 26,
  },
  {
    key: "auditor",
    name: "Auditor",
    description: "Read taxpayer data and run audit intelligence analyses.",
    users: 32,
    permissions: 19,
  },
  {
    key: "steward",
    name: "Data Steward",
    description: "Resolve data quality issues, duplicates and imports.",
    users: 20,
    permissions: 22,
  },
  {
    key: "readonly",
    name: "Read Only",
    description: "View dashboards and reports without making changes.",
    users: 48,
    permissions: 9,
  },
];
